/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.15",
    versionName: "0.2.0-nightly.2026.3.15",
    versionChannel: "nightly",
    buildDate: "2026-03-15T00:12:06.654Z",
    commitHash: "71f18f0d0e3bd118945d5956f4ac4bb2e486e856",
};
